/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import account from '../action/accountAction'

export const initialState = ({
  isLoading: false,
  invoices: null,
  status: null,
})


export default function (state = initialState, action) {
  switch (action.type) {

    case account.TYPES.REQUEST_INVOICE:
      return Object.assign({}, state, { invoices: null, isLoading: true, status: null})

    case account.TYPES.REQUEST_INVOICE_SUCCESS:
      return Object.assign({}, state, { invoices: action.payload, isLoading: false, status: null})

    case account.TYPES.UPDATE_INVOICE_LIST:
      return Object.assign({}, state, { invoices: action.payload, isLoading: false, status: null})

    default:
      return state
  }
}
